export const PAYEE_TYPE={//分账方类型
1:'平台',
2:'物业（停车场）',
3:'个人'
}

export const PROFIT_TYPE={//分账类型
    1:'比例分账',
    // 2:'固定金额分账',

    }
